module.exports = __webpack_public_path__ + "img/regular_lease_overview_icon01.c78b0ecd.svg";